import clsx from "clsx";
import { ButtonHTMLAttributes, FunctionComponent } from "react";

import CloseIcon from "@ui/components/icon/CloseIcon";

import * as styles from "./CloseButton.css";

const CloseButton: FunctionComponent<
  ButtonHTMLAttributes<HTMLButtonElement>
> = ({ className, ...props }) => {
  return (
    <button
      className={clsx(styles.button, className)}
      {...props}
      aria-label="Close Drawer"
    >
      <span>close</span>
      <CloseIcon className={styles.icon} />
    </button>
  );
};

export default CloseButton;
